// getConfig
import axios from 'axios';

export default function getLanguage() {
    const url = `${window.location.protocol}//${window.location.host}/config/languages.json`;
    console.log(url);

    return {
        type: 'LANGUAGE_FETCH',
        payload: axios.get(url)
    };
}